import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "login-container",
  ref: "loginContainer"
}
const _hoisted_2 = {
  ref: "waveCanvas",
  class: "bg-wave-canvas",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "login-card" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "checkbox-group" }
const _hoisted_7 = { class: "modal-content login-error-modal" }
const _hoisted_8 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", _hoisted_2, null, 512),
    _createElementVNode("div", _hoisted_3, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "brand-wrap" }, [
        _createElementVNode("img", {
          src: "/logo.png",
          alt: "JMASysc",
          class: "brand-logo"
        })
      ], -1)),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "logo-section" }, [
        _createElementVNode("p", { class: "slogan" }, "Transformando ideias em inovações.")
      ], -1)),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleLogin && $setup.handleLogin(...args)), ["prevent"])),
        class: "login-form"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "usuario" }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            id: "usuario",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.credentials.usuario) = $event)),
            required: "",
            placeholder: "Digite seu email"
          }, null, 512), [
            [_vModelText, $setup.credentials.usuario]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { for: "senha" }, "Senha", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            id: "senha",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.credentials.senha) = $event)),
            required: "",
            placeholder: "Digite sua senha"
          }, null, 512), [
            [_vModelText, $setup.credentials.senha]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "salvarUsuario",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.salvarUsuario) = $event))
          }, null, 512), [
            [_vModelCheckbox, $setup.salvarUsuario]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("label", { for: "salvarUsuario" }, "Salvar usuário", -1))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "form-actions" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-dark"
          }, " Entrar ")
        ], -1))
      ], 32)
    ]),
    ($setup.showErrorModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.showErrorModal = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", null, "Erro ao entrar", -1)),
            _createElementVNode("p", null, _toDisplayString($setup.errorMessage), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-dark",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showErrorModal = false))
              }, " Fechar ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}